import extend from 'extend';
import md5 from 'js-md5';
import _ from 'lodash';
import Message from 'element-ui/lib/message';
import MessageBox from 'element-ui/lib/message-box';
import {
  env,
  envPrefix,
} from './env';
import ClipboardJS from 'clipboard';

// 深拷贝
// 判断是否为复杂数据类型
function needDeepCopy(source) {
  // return ['Object', 'Array'].includes(Object.prototype.toString.call(source).slice(8, -1));
  return _.includes(['Object', 'Array'], Object.prototype.toString.call(source).slice(8, -1));
}

// 深拷贝主方法
function deepCopy(source) {

  // 不考虑 symbol、循环引用
  if (!needDeepCopy(source)) {
    return source;
  }
  const target = Array.isArray(source) ? [] : {};

  Object.keys(source).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (needDeepCopy(source[key])) {
        target[key] = deepCopy(source[key]);
      } else {
        target[key] = source[key];
      }
    }
  });
  return target;
}

// 计算时间差是否大于1天
function isDifferenceGreaterThanOneDay(date1, date2) {
  // 将两个日期转换为毫秒时间戳
  const time1 = new Date(date1).getTime();
  const time2 = new Date(date2).getTime();

  // 计算时间差（毫秒）
  const timeDifference = Math.abs(time2 - time1);

  // 一天的毫秒数
  const oneDay = 24 * 60 * 60 * 1000;

  // 判断时间差是否大于一天
  return timeDifference > oneDay;
}

function getDaysDifference(date1, date2) {
  // 将日期字符串转换为 Date 对象
  const startDate = new Date(date1);
  const endDate = new Date(date2);
  endDate.setHours(23, 59, 59, 999);
  
  // 计算两个日期的时间戳差值（以毫秒为单位）
  const timeDifference = endDate - startDate;
  
  // 将时间戳差值转换为天数
  const dayDifference = timeDifference / (1000 * 60 * 60 * 24);
  
  return Math.abs(dayDifference); // 返回天数差的绝对值
}

export default {

  materialByIndentity(data) {
    if (!data || !data.material) {
      return [];
    }
  },

  createArray(len) {
    const array = [];
    for (let i = 1; i < len + 1; i++) {
      array.push(i);
    }
    return array;
  },

  removeClass(el, classname) {
    el.classList ? el.classList.remove(classname) : (el.className = el.className.replace(
      new RegExp(`(^|\\b)${classname}(\\b|$)`, 'gi'), ' '));
  },

  trigger(el, type, bubble, cancel) {
    const event = document.createEvent('HTMLEvents');
    event.initEvent(type, bubble !== undefined ? bubble : false, cancel !== undefined ? cancel : true);
    el.dispatchEvent(event);
  },

  getOffsetTop(el) {
    if (el.offsetParent) {
      return el.offsetTop + this.getOffsetTop(el.offsetParent);
    }
    return el.offsetTop;
  },

  // debounce(防抖动函数)
  debounce(func, wait) {
    let timeout = null;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  },

  decodeParam(paramString) {
    if (paramString) {
      const keyValueArr = decodeURIComponent(paramString).split(';');
      const result = {};
      keyValueArr.forEach((keyValue) => {
        if (keyValue.indexOf('=') > -1) {
          const tempResult = keyValue.split('=');
          result[tempResult[0]] = tempResult[1];
        }
      });
      return result;
    }
    return null;
  },

  formatParam(paramsObj) {
    if (paramsObj) {
      const keyValueArr = [];
      Object.keys(paramsObj).forEach((key) => {
        keyValueArr.push(`${key}=${paramsObj[key]}`);
      });
      return encodeURIComponent(keyValueArr.join(';'));
    }
    return '';
  },

  toBase64(f) {
    return new Promise(((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = function (e) {
        resolve(e.target.result);
      };
      fr.onerror = function () {
        reject('解析图片文件失败');
      };
      fr.readAsDataURL(f);
    }));
  },

  forEach(obj, func) {
    Object.keys(obj).forEach((k) => {
      func(obj[k], k);
    });
  },

  /**
   * 随机字符
   * @param {any} len
   * @returns
   */
  ranString(len) {
    len = len || 32;
    const $chars = 'abcdefghijklmnopqrstuvwxyz1234567890'; /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1*** */
    const maxPos = $chars.length;
    let ranstr = '';
    for (let i = 0; i < len; i++) {
      ranstr += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return ranstr;
  },

  jsLoad(url) {
    return new Promise(((resolve, reject) => {
      const nScript = document.createElement('script');
      nScript.src = url;

      nScript.onload = function () {
        resolve();
        document.head.removeChild(nScript);
      };
      nScript.onerror = function () {
        reject();
      };

      document.head.appendChild(nScript);
    }));
  },

  statsTrigger(channel, data) {
    if (!env) {
      const postData = {
        extend: data,
      };

      const url = `https://${envPrefix}api.11visa.com/oss/open/channel_stat?channel=${channel}`;
      const xhr = new XMLHttpRequest();
      xhr.open('post', url);
      xhr.send(JSON.stringify(postData));
    }
  },

  // 过渡结束函数的兼容性写法
  transitionEnd(obj, callback) {
    if (obj && typeof obj === 'object') {
      obj.addEventListener('webkitTransitionEnd', () => { // 兼容写法
        callback && callback(); // && 运算符 , 如果callback函数存在,则调用callback()函数
      });
      obj.addEventListener('transitionend', () => {
        callback && callback();
      });
    }
  },

  importImage(path) {
    const images = require.context('../assets/imgs', true);
    return images(`./${path}`);
  },

  // 滚到某个元素
  scrollToElement(selector, offset) {

    // 这个是兼容所有浏览器的取值滚动距的办法
    const windowScrollTop = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0);

    // 这个是取值当前元素距离页面顶部的距离，如果元素在顶部下面，则为正，如果元素在顶部上面，则为复数
    const currentElementToTop = document.querySelector(selector).getBoundingClientRect().top;

    // offset一般是处理fixed定位的header遮住的问题，简单说就是如果不减去offset，元素会滚动到顶部，然后就被fixed定位的元素遮住了
    try {
      if (this.isIE()) {
        window.scroll(0, windowScrollTop + currentElementToTop - offset);
      } else {
        // 使用option存在部分浏览器兼容问题，当报错时使用普通直接跳转
        window.scrollTo({
          top: windowScrollTop + currentElementToTop - offset,
          left: 0,
          behavior: 'smooth',
        });
      }
    } catch (e) {
      window.scrollTo(0, windowScrollTop + currentElementToTop - offset);
    }

  },

  isIE() {
    if (!!window.ActiveXObject || 'ActiveXObject' in window) { return true; }
    return false;
  },

  // 页面scroll距离
  getPageScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  },

  padLeftZero(str) {
    return (`00${str}`).substr(str.length);
  },

  formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length));
    }
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
    };

    Object.keys(o).forEach((k) => {
      if (new RegExp(`(${k})`).test(fmt)) {
        const str = `${o[k]}`;
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : this.padLeftZero(str));
      }
    });
    return fmt;
  },

  // 滚到顶部
  scrollTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  },

  // 将读取本地图片封装成 Promise
  loadImage(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => resolve(reader.result), false);
      reader.addEventListener('error', () => reject, false);
      reader.readAsDataURL(file);
    });
  },

  throttle(fn, gapTime) {
    let lastTime = null;
    return function () {
      const nowTime = +new Date();
      if (nowTime - gapTime > lastTime || !lastTime) {
        fn();
        lastTime = nowTime;
      }
    };
  },

  /**
   * @desc 乘法函数，用来解决浮点数乘法精度丢失问题
   * @param {Number} arg1 乘数1
   * @param {Number} arg2 乘数2
   * @return {Number} arg1和arg2的乘后的值
   */
  mul(arg1, arg2) {
    // m:小数位的长度，s1:arg1转字符串,s2:arg2转字符串
    let m = 0;
    const s1 = arg1.toString();
    const s2 = arg2.toString();
    try {
      m += s1.split('.')[1].length;
    } catch (e) {
      m += 0;
    }
    try {
      m += s2.split('.')[1].length;
    } catch (e) {
      m += 0;
    }
    // 去除小数点后相乘，除一个10的m次方（相当于将小数点前移m位）
    // eslint-disable-next-line no-restricted-properties
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
  },


  // 解决浮点数相除精度不准确问题
  divide(arg1, arg2) {
    let t1 = 0;
    let t2 = 0;
    let r1 = 0;
    let r2 = 0;
    t1 = arg1.toString().split('.')[1] ? arg1.toString().split('.')[1].length : 0;
    t2 = arg2.toString().split('.')[1] ? arg2.toString().split('.')[1].length : 0;
    r1 = Number(arg1.toString().replace('.', ''));
    r2 = Number(arg2.toString().replace('.', ''));
    return this.mul((r1 / r2), Math.pow(10, t2 - t1));
  },

  // multiply(arg1, arg2) {
  // // m:小数位的长度，s1:arg1转字符串,s2:arg2转字符串
  //   let t1 = 0;
  //   let t2 = 0;
  //   let r1 = 0;
  //   let r2 = 0;
  //   t1 = arg1.toString().split('.')[1] ? arg1.toString().split('.')[1].length : 0;
  //   t2 = arg2.toString().split('.')[1] ? arg2.toString().split('.')[1].length : 0;
  //   r1 = Number(arg1.toString().replace('.', ''));
  //   r2 = Number(arg2.toString().replace('.', ''));
  //   // 去除小数点后相乘，除一个10的m次方（相当于将小数点前移m位）
  //   return r1 * r2 / Math.pow(10, t2 + t1);
  // },


  // 折扣的处理 5.0显示打5折  5.2折显示 5.2
  formatNumberWithDecimals(value) {
    // 将值转换为数字类型
    const num = Number(value);
    // 如果转换后的值为 NaN，则返回原始值
    if (isNaN(num)) {
      return value;
    }
    // 使用 toFixed(2) 方法将数字保留两位小数，并转换为字符串
    let formatted = num.toFixed(2);
    // 检查小数部分是否为 ".00"
    if (formatted.endsWith('.00')) {
      // 如果是，返回整数部分
      return num.toString().split('.')[0];
    }
    // 检查小数部分是否为 ".X0"
    if (formatted.endsWith('0')) {
      // 如果是，去掉最后一位0
      formatted = formatted.slice(0, -1);
    }
    // 如果小数点后的内容是 ".0"，去掉 ".0"
    if (formatted.endsWith('.0')) {
      formatted = formatted.slice(0, -2);
    }
    return formatted;
  },

  copyText(text) {
    return new Promise((resolve) => {
      const el = document.createElement('div');
      el.id = 'copy-el';
      el.setAttribute('data-clipboard-text', text);

      document.body.appendChild(el);
      // eslint-disable-next-line no-new
      new ClipboardJS('#copy-el', {
        text(trigger) {
          return trigger.getAttribute('data-clipboard-text');
        },
      });
      el.click();
      document.body.removeChild(el);
      resolve();
    });
  },
  // 下载URL文件
  downloadUrlToFile(url) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
  
      xhr.responseType = 'blob';
  
      xhr.onload = function () {
        if (xhr.status === 200) {
          resolve(xhr.response);
        } else {
          reject();
        }
      };
  
      xhr.onerror = function () {
        reject();
      };
  
      xhr.open('GET', url, true);
      xhr.send();
    });
    
  },

  isValidDate(dateString) {
    // 创建 Date 对象
    const date = new Date(dateString);
    // 判断是否为合法日期
    return !Number.isNaN(date.getTime());
  },

  deepCopy,
  extend,
  isDifferenceGreaterThanOneDay,
  getDaysDifference,
  md5,
  Promise,
  msg: Message,
  msgbox: MessageBox,
};



// WEBPACK FOOTER //
// ./src/libs/utils.js